import React, { memo, useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  Checkbox,
  Box,
  InputAdornment,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  NativeSelect,
  TextField,
  CircularProgress,
  TableSortLabel,
  Select,
  MenuItem,
  Button,
  Stack,
  Tooltip,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import configServ from "../../services/config";
import Constants from "../../utility/Constants";
import SearchBox from "../../Components/Search/SearchBox";
import CheckAndReturn from "../../utility/CheckAndReturn";
import { useLocation, useNavigate } from "react-router-dom";
import useDebounce from "../../Components/hooks/useDebounce";
import UploadImage from "../../Components/Upload/UploadImage";
import VoucherOrientation from "../../Components/Voucher/VoucherOrientation";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";

import useDeviceDetect from "../../Components/Detect/useDeviceDetect ";
import LoaderNew from "../../Components/Loader/LoaderNew";
import MobileView from "../../Components/views/MobileView";
import DesktopView from "../../Components/views/DesktopView";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion";
//FUNCTION
const BudgetTable1 = ({ handleEditData, isChanged, isEdit }) => {
  //#region code
  const navigate = useNavigate();
  const { user_id, company_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const rowsPerPageOptions = [20, 50, 100, 200];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[1]);
  const [voucherList, setVoucherList] = useState([]);
  const [accountClassified, setAccountClassified] = useState([]);
  const [searchBy, setSearchBy] = useState("budget_code");
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);
  const [count, setCount] = useState(0);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("budget_code");
  const [loading, setLoading] = useState(true);

  const [printOpen, setPrintOpen] = useState(false);
  const [printData, setPrintData] = useState({});
  const [openImg, setOpenImg] = useState(false);
  const [Img, setImg] = useState("");
  const location = useLocation();
  const { entity_number, entity } = location.state || {};
  const [redirectVoucherNo, setRedirectVoucherNo] = useState(entity_number);
  const [entity_type, setEntity_type] = useState(entity ? entity : "account");

  const fetchAccountClassified = async () => {
    try {
      const res = await configServ.getAccountClassified();
      if (res.status === 200) {
        setAccountClassified(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchAccountClassified();
  }, []);

  // useEffect(() => {
  //   if (redirectVoucherNo) {
  //     setSearchBy("budget_code");
  //     setSearch(redirectVoucherNo);
  //     fetchVoucherList("budget_code", redirectVoucherNo);
  //   } else {
  //     setSearchBy("budget_code");
  //     setSearch("");
  //   }
  // }, [redirectVoucherNo]);

  useEffect(() => {
    if (!redirectVoucherNo) {
      fetchVoucherList();
    }
  }, [isChanged, page, rowsPerPage, order, orderBy]);

  useEffect(() => {
    if (!redirectVoucherNo) {
      if (page === 0) {
        fetchVoucherList();
      } else {
        setPage(0);
      }
    }
  }, [debounceSearch, entity_type]);

  const fetchVoucherList = async (searchByVch = null, VchNo = null) => {
    try {
      setLoading(true);
      const dataToSend = {
        is_super: is_super,
        user_id: user_id,
        company_id: company_id,
        search_by: searchByVch ? searchByVch : searchBy,
        search: VchNo ? VchNo : debounceSearch,
        per_page: rowsPerPage,
        page: page,
        sort_by: orderBy,
        order,
        entity_type: entity_type,
      };
      const res = await configServ.getBudgets(dataToSend);
      if (res.status === 200) {
        setVoucherList(res.data);
        setCount(res.total);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const headers = [
    // { id: "fname", label: "Account" },
    { id: "project", label: "Project" },
    { id: "budget_code", label: "Budget Code" },
    { id: "budget_date", label: "Date" },
    { id: "total_amount", label: "Amount" },
  ];

  const headerCellStyle = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#4CB5F5",
    color: "white",
  };
  const headerCellStyleSub = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#05b3de",
    color: "white",
  };

  const bodyCellStyle = {
    py: 0,
    my: 1,
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearchBy = (event) => {
    try {
      setSearchBy(event.target.value);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (params) => {
    const data = voucherList.filter((x) => x.id === params);
    handleEditData(data);
  };

  const handleImage = (params) => {
    try {
      const data = voucherList.find((x) => x.id === params);

      if (!data) {
        console.log("Data not found");
        return;
      }

      if (data.extension === "pdf") {
        // Decode base64 string to binary
        const byteCharacters = atob(data.image);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob from the binary data
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const pdfURL = URL.createObjectURL(blob);

        // Open the Blob URL in a new tab
        window.open(pdfURL, "_blank");

        // Optional: Revoke the Object URL after some time
        setTimeout(() => URL.revokeObjectURL(pdfURL), 5000);
      } else if (data.is_image) {
        // Handle image
        const image = `data:image/${data.extension};base64,${data.image}`;
        setOpenImg(true);
        setImg(image);
      } else {
        console.log("Unsupported format");
      }
    } catch (e) {
      console.log("Error:", e);
    }
  };

  const evenRowStyle = {
    background: "#f5f5f5",
  };

  const oddRowStyle = {
    background: "white",
  };

  const rowStyle = {
    "&:hover": {
      background: "#f1f9fe",
    },
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleAccountClassified = (params) => {
    try {
      const classifiedRow = accountClassified.find(
        (x) => x.PK.toString() === params.toString()
      );
      if (classifiedRow) {
        return classifiedRow.accountclassified;
      } else {
        return "N/A";
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleEntityType = (params) => {
    try {
      const { name, value } = params.target;
      setEntity_type(value);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCustomerClick = (params) => {
    try {
      const data = params;
      navigate("/account-master-entry/customers", { state: data });
    } catch (e) {
      console.log(e);
    }
  };

  const printVoucher = async (voucher) => {
    const data = {
      id: voucher.id,
      budget_code: voucher.budget_code,
      user_id: user_id,
      company_id: company_id,
    };
    setPrintOpen(true);
    setPrintData(data);
  };

  const handleVoucherPrint = (params) => {
    const data = voucherList.filter((x) => x.id === params.id);
    printVoucher(data[0]);
  };

  const handleCloseImg = () => {
    setOpenImg(false);
  };

  // -----------------------tabel sub menu start ------------------------>>

  const [accountList, setAccountList] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [products, setProducts] = useState([]);
  const [costMasterList, setCostMasterList] = useState([]);
  const variants = {
    hidden: { opacity: 0, height: 0 },
    visible: { opacity: 1, height: "auto" },
  };
  const fetchAccountList = async () => {
    try {
      const res = await configServ.getAllAccountMasters({
        company_id: company_id,
      });
      if (res.status === 200) {
        const result = res.data.filter((x) => x.status === 1);
        setAccountList(result);
      } else {
        setAccountList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSupplierList = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
      };
      const res = await configServ.getSupplier(dataToSend);
      if (res.status === 200) {
        const result = res.data.filter((x) => x.status === 1);
        setSuppliers(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchLocation = async () => {
    try {
      const res = await configServ.getLocation({
        company_id: company_id,
      });
      if (res.length > 0) {
        const locationResponse = res.filter((x) => x.status === 1);
        const result = locationResponse.sort((a, b) =>
          a.location_name.localeCompare(b.location_name)
        );
        setLocations(result);
      } else {
        setLocations([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchItemList = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getItemList(dataToSend);
      if (res.status === 200) {
        if (res.data.length > 0) {
          const result = res.data.filter((x) => x.status === 1);
          setProducts(result);
        } else {
          setProducts([]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCostMaster = async () => {
    try {
      const res = await configServ.getAllCostMasters();
      if (res.status === 200) {
        const result = res.data.filter((x) => x.status === 1);
        setCostMasterList(result || []);
      } else {
        setCostMasterList([]);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchAccountList();
    fetchSupplierList();
    fetchLocation();
    fetchItemList();
    fetchCostMaster();
  }, []);

  const [expandedRows, setExpandedRows] = useState({});

  const handleExpandRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  //#endregion

  return (
    <Paper sx={{ width: "100%" }}>
      <UploadImage open={openImg} handleClose={handleCloseImg} Img={Img} />

      <VoucherOrientation
        open={printOpen}
        setOpen={setPrintOpen}
        data={printData}
      />

      <Grid
        container
        alignItems="flex-end"
        justifyContent="flex-start"
        sx={{ mb: 1 }}
        spacing={1}
        direction={"row"}
      >
        <Grid item xs={12} md={6} justifyContent={"flex-start"}>
          <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
            Budget List: {count}
          </Typography>
        </Grid>
        {/* <Grid
          item
          xs={12}
          md={3}
          justifyContent={"flex-start"}
          sx={{
            mt: { xs: 2, md: 0 }, // Add margin top for mobile devices
          }}
        >
          <FormControl fullWidth size="small">
            <InputLabel>Account Type</InputLabel>
            <Select
              fullWidth
              size="small"
              variant="standard"
              sx={{ background: "white" }}
              label={"Type"}
              name="entity_type"
              value={entity_type}
              onChange={handleEntityType}
            >
              {Constants.EntityTypes.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        {redirectVoucherNo ? (
          <>
            <Grid container item xs={12} md={6} justifyContent={"flex-end"}>
              <Button
                variant="contained"
                title="Referesh"
                color="success"
                startIcon={<RefreshIcon sx={{ ml: 1, color: "white" }} />}
                onClick={() => {
                  setRedirectVoucherNo(null);
                }}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                mt: { xs: 2, md: 0 }, // Add margin top for mobile devices
              }}
            >
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel
                    variant="standard"
                    htmlFor="uncontrolled-native"
                    sx={{ ml: { xs: 2, md: 0 } }}
                  >
                    Search By
                  </InputLabel>
                  <NativeSelect
                    defaultValue={"budget_code"}
                    onChange={handleSearchBy}
                    inputProps={{
                      name: "searchBy",
                      id: "uncontrolled-native",
                    }}
                  >
                    <option value={"budget_code"}>Budget Code</option>
                  </NativeSelect>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} justifyContent={"flex-end"}>
              <SearchBox search={search} setSearch={setSearch} />
            </Grid>
          </>
        )}
      </Grid>

      <MobileView>
        <Grid container alignItems="center" spacing={1} mt={1}>
          {/* Sort By Dropdown */}
          <Grid item xs={6} md={6} justifyContent="center">
            <FormControl fullWidth size="small">
              <InputLabel>Sort By</InputLabel>
              <Select
                fullWidth
                size="small"
                name="order_by"
                label="Sort By"
                value={orderBy}
                onChange={(e) => setOrderBy(e.target.value)}
                sx={{ background: "white" }}
              >
                {headers.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Order Dropdown */}
          <Grid item xs={6} md={6} justifyContent="center">
            <FormControl fullWidth size="small">
              <InputLabel>Order</InputLabel>
              <Select
                fullWidth
                size="small"
                name="order"
                label="Order"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
                sx={{ background: "white" }}
              >
                <MenuItem key={1} value="asc">
                  Ascending
                </MenuItem>
                <MenuItem key={2} value="desc">
                  Descending
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Data Display */}
        <Grid container spacing={2} sx={{ py: 2 }}>
          {loading ? (
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <LoaderNew />
            </Grid>
          ) : voucherList.length > 0 ? (
            voucherList.map((row, index) => (
              <Grid item xs={12} key={row.id}>
                <Paper elevation={3} sx={{ p: 2 }}>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Project:
                    </span>{" "}
                    {row.project.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Budget Code:
                    </span>{" "}
                    {row.budget_code}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Date:
                    </span>{" "}
                    {CheckAndReturn.transformToDate3(row.budget_date)}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Amount:
                    </span>{" "}
                    {row.total_amount}
                  </Typography>

                  {/* Action Buttons */}
                  <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                    {Boolean(
                      is_super || is_admin || permissions.includes(32)
                    ) && (
                      <Tooltip title="Edit" placement="top">
                        <IconButton onClick={() => handleEdit(row.id)}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    )}

                    {/* Expand Button */}
                    <Tooltip title="Expand">
                      <IconButton onClick={() => handleExpandRow(row.id)}>
                        {expandedRows[row.id] ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </IconButton>
                    </Tooltip>
                  </Stack>

                  {/* Expanded Row */}
                  {expandedRows[row.id] && (
                    <Box
                      sx={{
                        mt: 2,
                        p: 2,
                        background: "#f5f5f5",
                        borderRadius: "8px",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold", mb: 1 }}
                      >
                        Details:
                      </Typography>
                      {row.budget_items.map((item) => (
                        <Paper key={item.id} sx={{ p: 1, mb: 1 }}>
                          <Typography variant="body2">
                            <b>Account:</b>{" "}
                            {accountList.find((a) => a.id === item.account)
                              ?.accountname || "N/A"}
                          </Typography>
                          <Typography variant="body2">
                            <b>Product:</b>{" "}
                            {products.find((p) => p.id === item.product)
                              ?.item_name || "N/A"}
                          </Typography>
                          <Typography variant="body2">
                            <b>Cost Master:</b>{" "}
                            {costMasterList.find(
                              (c) => c.id === item.costmaster
                            )?.name || "N/A"}
                          </Typography>
                          <Typography variant="body2">
                            <b>Location:</b>{" "}
                            {locations.find((l) => l.id === item.location)
                              ?.location_name || "N/A"}
                          </Typography>
                          <Typography variant="body2">
                            <b>Currency:</b> {item.currency}
                          </Typography>
                          <Typography variant="body2">
                            <b>Amount:</b> {item.amount}
                          </Typography>
                        </Paper>
                      ))}
                    </Box>
                  )}
                </Paper>
              </Grid>
            ))
          ) : (
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Box sx={{ color: "red", fontWeight: 600 }}>No data found.</Box>
            </Grid>
          )}
        </Grid>

        {/* Pagination */}
        {!loading && voucherList.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        )}
      </MobileView>

      <DesktopView>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100vh", // Set full height
          }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell sx={headerCellStyle}>S.No.</TableCell>
                {headers.map((column) => (
                  <TableCell
                    key={column.id}
                    sortDirection={orderBy === column.id ? order : false}
                    sx={headerCellStyle}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() => handleRequestSort(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
                <TableCell sx={headerCellStyle}>Action</TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody>
                <TableRow>
                  <TableCell
                    colSpan={headers.length + 2}
                    sx={{ textAlign: "center" }}
                  >
                    <LoaderNew />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {voucherList.length > 0 ? (
                  voucherList.map((row, index) => (
                    <React.Fragment key={row.id}>
                      {/* Parent Row */}
                      <TableRow
                        sx={{
                          ...rowStyle,
                          ...(index % 2 === 0 ? evenRowStyle : oddRowStyle),
                        }}
                      >
                        <TableCell sx={bodyCellStyle}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {row.project.name}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {row.budget_code}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {CheckAndReturn.transformToDate3(row.budget_date)}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          {row.total_amount}
                        </TableCell>
                        <TableCell sx={bodyCellStyle}>
                          <Stack direction="row">
                            <Box
                              display={
                                Boolean(
                                  is_super ||
                                    is_admin ||
                                    permissions?.includes(32)
                                )
                                  ? "block"
                                  : "none"
                              }
                            >
                              <Tooltip title="Edit" placement="top">
                                <IconButton onClick={() => handleEdit(row.id)}>
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Expand">
                                <IconButton
                                  onClick={() => handleExpandRow(row.id)}
                                >
                                  {expandedRows[row.id] ? (
                                    <ExpandLessIcon />
                                  ) : (
                                    <ExpandMoreIcon />
                                  )}
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Stack>
                        </TableCell>
                      </TableRow>

                      {/* Expanded Row */}
                      {expandedRows[row.id] && (
                        <TableRow>
                          <TableCell
                            colSpan={headers.length + 2}
                            sx={{ padding: 0 }}
                          >
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell sx={headerCellStyleSub}>
                                    Account
                                  </TableCell>
                                  <TableCell sx={headerCellStyleSub}>
                                    Product
                                  </TableCell>
                                  <TableCell sx={headerCellStyleSub}>
                                    Cost Master
                                  </TableCell>
                                  <TableCell sx={headerCellStyleSub}>
                                    Location
                                  </TableCell>
                                  <TableCell sx={headerCellStyleSub}>
                                    Currency
                                  </TableCell>
                                  <TableCell sx={headerCellStyleSub}>
                                    Amount
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {row.budget_items.map((item) => (
                                  <TableRow key={item.id}>
                                    <TableCell>
                                      {accountList.find(
                                        (a) => a.id === item.account
                                      )?.accountname || "N/A"}
                                    </TableCell>
                                    <TableCell>
                                      {products.find(
                                        (p) => p.id === item.product
                                      )?.item_name || "N/A"}
                                    </TableCell>
                                    <TableCell>
                                      {costMasterList.find(
                                        (c) => c.id === item.costmaster
                                      )?.name || "N/A"}
                                    </TableCell>
                                    <TableCell>
                                      {locations.find(
                                        (l) => l.id === item.location
                                      )?.location_name || "N/A"}
                                    </TableCell>
                                    <TableCell>{item.currency}</TableCell>
                                    <TableCell>{item.amount}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={headers.length + 2}
                      sx={{ textAlign: "center" }}
                    >
                      <Box sx={{ color: "red", fontWeight: 600 }}>
                        No data found.
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </DesktopView>
    </Paper>
  );
};

export default memo(BudgetTable1);
